import React, { createContext, useContext, useEffect, useState } from 'react';

const DEFAULTS = {
  clinic_name: 'Dr. Priya Nair Clinic',
  doctor_name: 'Dr. Priya Nair',
  clinic_phone: '+91 98765 12345',
  clinic_landline: '020 4321 5678',
};

const SettingsContext = createContext({
  settings: DEFAULTS,
  updateSettings: () => {},
  resetSettings: () => {},
});

const STORAGE_KEY = 'fora.settings.v1';

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
    } catch (e) { /* ignore */ }
    return DEFAULTS;
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch (e) { /* ignore */ }
  }, [settings]);

  // Keep multiple tabs in sync (e.g. TV display window listens for changes on the operator's tab)
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        try { setSettings({ ...DEFAULTS, ...JSON.parse(e.newValue) }); } catch (err) { /* ignore */ }
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const updateSettings = (patch) => setSettings(prev => ({ ...prev, ...patch }));
  const resetSettings = () => setSettings(DEFAULTS);

  return (
    <SettingsContext.Provider value={{ settings, updateSettings, resetSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
